import { Text } from "@simplybusiness/mobius";
import type { OpeningHoursEntry as OpeningHoursEntryType } from "../../types";

export const OpeningHoursEntry = (props: OpeningHoursEntryType) => {
  const { day, hours } = props;

  return (
    <>
      <Text variant="small" elementType="span">
        {day}
      </Text>
      <Text variant="small" elementType="span">
        {hours}
      </Text>
    </>
  );
};
